import { render } from "./MNotificationSettingModal.vue?vue&type=template&id=6388ca43&scoped=true&ts=true"
import script from "./MNotificationSettingModal.vue?vue&type=script&lang=ts"
export * from "./MNotificationSettingModal.vue?vue&type=script&lang=ts"

import "./MNotificationSettingModal.vue?vue&type=style&index=0&id=6388ca43&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6388ca43"]])

export default __exports__